var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thank-you"},[_c('title-without-login',[_vm._v(_vm._s(_vm.thankYou)+" ")]),_c('message-basic',[_vm._v(_vm._s(_vm.appFromHome)+" ")]),_c('message-basic',[_vm._v(_vm._s(_vm.please)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }